import { Plugin } from "prosemirror-state";

import type { EDITOR_MODE } from "../constants";
import {
  getImageFilesFromDataTransfer,
  insertImageFilesIntoEditor,
} from "./image-files";

export const editorDropPlugin = ({
  mode,
  uploadImageFile,
}: {
  mode: EDITOR_MODE;
  uploadImageFile?: (file: File) => Promise<string | null>;
}) =>
  new Plugin({
    props: {
      handleDrop(view, event) {
        const dataTransfer = event.dataTransfer;

        if (!dataTransfer?.files.length) {
          return false;
        }

        const imageFiles = getImageFilesFromDataTransfer(dataTransfer);

        if (!imageFiles.length) {
          return false;
        }

        event.preventDefault();

        const dropPosition = view.posAtCoords({
          left: event.clientX,
          top: event.clientY,
        });
        const insertAt = dropPosition?.pos ?? view.state.selection.from;
        return insertImageFilesIntoEditor({
          files: imageFiles,
          insertAt,
          mode,
          uploadImageFile,
          view,
        });
      },
    },
  });
